import { Box, BoxProps, useMantineTheme } from '@mantine/core';

export const GreyBox: React.FC<BoxProps> = ({ children, ...props }) => {
  const theme = useMantineTheme();

  return (
    <Box
      p={16}
      bg={theme.other.background}
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 16,
        borderRadius: 4,
      }}
      {...props}
    >
      {children}
    </Box>
  );
};
